module.exports = require('./src/js-md5-file');